
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/[...slug]",
      function () {
        return require("private-next-pages/policies/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/[...slug]"])
      });
    }
  